import React from "react";
import Navbar from "../NavBar/NavBar";

const Header = () => {
  return (
    <>
      <Navbar />
    </>
  );
};

export default Header;
